var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useImmer } from 'use-immer';
export default function useObject(initialValue) {
    var _a = __read(useImmer(initialValue), 2), copy = _a[0], rawSet = _a[1];
    var set = function (data, value) {
        if (typeof data === 'string') {
            rawSet(function (draft) {
                var key = data;
                var v = value;
                draft[key] = v;
            });
        }
        else if (typeof data === 'function') {
            rawSet(data);
        }
        else if (typeof data === 'object') {
            rawSet(function (draft) {
                var e_1, _a;
                var obj = data;
                try {
                    for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var key = _c.value;
                        var k = key;
                        draft[k] = obj[k];
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            });
        }
    };
    return [copy, set];
}
